import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class BatchSelectController extends Controller {
  static targets = ['checkbox', 'selectAll', 'actionBar', 'count']
  static values = { formId: { type: String, default: 'bulk-order-form' } }

  connect () {
    this.updateState()
  }

  toggle () {
    this.updateState()
  }

  toggleAll () {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => { cb.checked = checked })
    this.updateState()
  }

  clearAll () {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
    this.updateState()
  }

  openRejectDrawer (event) {
    event.preventDefault()

    const drawerId = event.params.drawerId
    const dialog = document.getElementById(drawerId)
    if (!dialog) return

    const container = dialog.querySelector('#bulk-reject-items')
    container.innerHTML = ''

    this.checkedBoxes.forEach(cb => {
      const id = cb.value
      const name = cb.dataset.itemName || `Item #${id}`
      const artworkUrl = cb.dataset.artworkUrl

      const wrapper = document.createElement('div')
      wrapper.className = 'flex gap-3'

      if (artworkUrl) {
        const img = document.createElement('img')
        img.src = artworkUrl
        img.alt = name
        img.className = 'w-14 h-14 rounded-lg object-cover shrink-0 border border-black/10'
        wrapper.appendChild(img)
      }

      const fields = document.createElement('div')
      fields.className = 'flex flex-col gap-1 flex-1'

      const label = document.createElement('label')
      label.className = 'text-xs font-semibold text-text-secondary'
      label.textContent = name

      const textarea = document.createElement('textarea')
      textarea.name = `rejection_reasons[${id}]`
      textarea.rows = 2
      textarea.className = 'form__field w-full text-sm'
      textarea.placeholder = 'Reason (optional)'

      fields.appendChild(label)
      fields.appendChild(textarea)
      wrapper.appendChild(fields)
      container.appendChild(wrapper)
    })

    dialog.showModal()
  }

  submitTo (event) {
    event.preventDefault()
    if (event.params.confirm && !window.confirm(event.params.confirm)) return

    const form = document.getElementById(this.formIdValue)
    form.action = event.params.url

    let methodField = form.querySelector('input[name="_method"]')
    if (event.params.method && event.params.method !== 'post') {
      if (!methodField) {
        methodField = document.createElement('input')
        methodField.type = 'hidden'
        methodField.name = '_method'
        form.appendChild(methodField)
      }
      methodField.value = event.params.method
    } else if (methodField) {
      methodField.remove()
    }

    const btn = event.currentTarget
    const loadingText = btn.dataset.loadingText
    if (loadingText) {
      btn.disabled = true
      btn.textContent = loadingText
    }

    form.requestSubmit()
  }

  updateState () {
    const checkedCount = this.checkedBoxes.length
    const total = this.checkboxTargets.length

    if (checkedCount > 0) {
      this.actionBarTargets.forEach(bar => bar.classList.remove('hidden'))
      this.countTargets.forEach(el => { el.textContent = checkedCount })
    } else {
      this.actionBarTargets.forEach(bar => bar.classList.add('hidden'))
    }

    this.selectAllTarget.checked = total > 0 && checkedCount === total
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < total
  }

  get checkedBoxes () {
    return this.checkboxTargets.filter(cb => cb.checked)
  }
}

stimulus.register('batch-select', BatchSelectController)
